import { FC, useState } from "react";

import type { MainLineSettings, FibonacciSettings } from "../model";
import { FibonacciInputsTab } from "./FibonacciInputsTab";
import { FibonacciStylesTab } from "./FibonacciStylesTab";

import styles from "./styles/ToolSettingsModal.module.css";

type FibTab = "inputs" | "styles";

interface Props {
  mainLine: MainLineSettings;
  fibonacci: FibonacciSettings;
  onMainLineChange: (value: MainLineSettings) => void;
  onFibonacciChange: (value: FibonacciSettings) => void;
}

export const FibonacciModal: FC<Props> = ({
  mainLine,
  fibonacci,
  onMainLineChange,
  onFibonacciChange,
}) => {
  const [tab, setTab] = useState<FibTab>("inputs");

  return (
    <div>
      <div className={styles.tabBar}>
        <button
          className={`${styles.tab} ${tab === "inputs" ? styles.tabActive : ""}`}
          onClick={() => setTab("inputs")}
        >
          Inputs
        </button>
        <button
          className={`${styles.tab} ${tab === "styles" ? styles.tabActive : ""}`}
          onClick={() => setTab("styles")}
        >
          Styles
        </button>
      </div>
      {tab === "inputs" ? (
        <FibonacciInputsTab value={fibonacci} onChange={onFibonacciChange} />
      ) : (
        <FibonacciStylesTab
          mainLine={mainLine}
          fibonacci={fibonacci}
          onMainLineChange={onMainLineChange}
          onFibonacciChange={onFibonacciChange}
        />
      )}
    </div>
  );
};
